<p-table #dt [value]="filteredDeclarations" styleClass="p-datatable-striped p-datatable-sm"
  [globalFilterFields]="['model', 'clientName', 'tasks', 'responsible', 'executor', 'presentationType', 'observations']"
  [sortField]="sortField" [sortOrder]="sortOrder" [customSort]="!isServerSide" (sortFunction)="onSort($event)"
  [scrollable]="!isServerSide" [virtualScroll]="!isServerSide" [virtualScrollItemSize]="50"
  [scrollHeight]="isServerSide ? undefined : '700px'"
  [class.historic-server-table]="isServerSide"
  class="table is-stripped">

  <ng-template pTemplate="header">
    @if(configTable.filtersData) {
    <tr>
      @if(isServerSide) {
        <th scope="col" class="historic-col-expand"><span class="sr-only">Expandir</span></th>
      }
      @for (header of configTable.headers; track header.key) {

      @if(isServerSide && header.key === 'model') {
      <th scope="col" class="historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-model">Modelo</label>
        <p-multiSelect inputId="historic-filter-model"
          [options]="configTable.filtersData.models" [group]="true"
          optionLabel="name" optionValue="id" optionGroupLabel="department" optionGroupChildren="models"
          appendTo="body" [ngModel]="activeFilters.models" [placeholder]="header.name" showClear="true"
          (onClear)="onHistoricModelChange(null)" (onChange)="onHistoricModelChange($event)"
          [variant]="activeFilters.models?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'client') {
      <th scope="col" class="historic-filter-col historic-col-client-code">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-client-code">Cod. Cliente</label>
        <p-multiSelect inputId="historic-filter-client-code"
          [options]="clientCodes" optionLabel="code"
          optionValue="code" [filter]="true" filterBy="code" appendTo="body" [ngModel]="activeFilters.clientCodes"
          [placeholder]="header.name" showClear="true" (onClear)="onHistoricClientCodeChange(null)"
          (onChange)="onHistoricClientCodeChange($event)"
          [variant]="activeFilters.clientCodes?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'clientName') {
      <th scope="col" class="historic-filter-col historic-col-client">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-client">Cliente</label>
        <p-multiSelect inputId="historic-filter-client"
          [options]="configTable.filtersData.clients"
          optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name"
          [ngModel]="activeFilters.clients" [placeholder]="header.name" showClear="true"
          (onClear)="onHistoricClientChange(null)" (onChange)="onHistoricClientChange($event)"
          [variant]="activeFilters.clients?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'hasNotifications') {
      <th scope="col" class="historic-compact-col historic-col-avisos historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-avisos">Avisos</label>
        <p-dropdown inputId="historic-filter-avisos" [options]="yesNoOptions"
          optionLabel="label" optionValue="value" appendTo="body" [ngModel]="activeFilters.hasNotifications"
          [placeholder]="header.name" showClear="true" (onClear)="onHistoricHasNotificationsChange(null)"
          (onChange)="onHistoricHasNotificationsChange($event)"
          [variant]="activeFilters.hasNotifications != null ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'presentationType') {
      <th scope="col" class="historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-presentation">Tipo presentación</label>
        <p-multiSelect inputId="historic-filter-presentation"
          [options]="configTable.filtersData.presentationTypes"
          optionLabel="label" optionValue="label" appendTo="body" [ngModel]="activeFilters.presentationTypes"
          [placeholder]="header.name" showClear="true" (onClear)="onHistoricPresentationChange(null)"
          (onChange)="onHistoricPresentationChange($event)"
          [variant]="activeFilters.presentationTypes?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'state') {
      <th scope="col" class="historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-state">Estado</label>
        <p-multiSelect inputId="historic-filter-state"
          [options]="configTable.filtersData.statusOptions"
          optionLabel="label" optionValue="value" appendTo="body" [ngModel]="activeFilters.status"
          [placeholder]="header.name" showClear="true" (onClear)="onHistoricStatusChange(null)"
          (onChange)="onHistoricStatusChange($event)"
          [variant]="activeFilters.status?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'responsible') {
      <th scope="col" class="historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-responsible">Responsable</label>
        <p-multiSelect inputId="historic-filter-responsible"
          [options]="configTable.filtersData.users"
          optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name"
          [ngModel]="activeFilters.responsibles" [placeholder]="header.name" showClear="true"
          (onClear)="onHistoricResponsibleChange(null)" (onChange)="onHistoricResponsibleChange($event)"
          [variant]="activeFilters.responsibles?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'executor') {
      <th scope="col" class="historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-executor">Ejecutor</label>
        <p-multiSelect inputId="historic-filter-executor"
          [options]="configTable.filtersData.users"
          optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name"
          [ngModel]="activeFilters.executors" [placeholder]="header.name" showClear="true"
          (onClear)="onHistoricExecutorChange(null)" (onChange)="onHistoricExecutorChange($event)"
          [variant]="activeFilters.executors?.length ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'dateFinish') {
      <th scope="col" class="historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-date">Fecha de finalización</label>
        <p-calendar inputId="historic-filter-date" [iconDisplay]="'input'"
          [ngModel]="activeFilters.selectedPeriod"
          [showClear]="activeFilters.selectedPeriod?.length > 0" placeholder="Fecha finalización" dataType="date"
          dateFormat="dd/mm/yy" [showIcon]="true" selectionMode="range" appendTo="body"
          [variant]="activeFilters.selectedPeriod?.length ? 'filled' : 'outlined'" [readonlyInput]="true"
          (onClear)="onHistoricPeriodChange([])" (ngModelChange)="onHistoricPeriodChange($event)" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'observations') {
      <th scope="col" class="historic-compact-col historic-col-comments historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-comments">Comentarios</label>
        <p-dropdown inputId="historic-filter-comments" [options]="yesNoOptions"
          optionLabel="label" optionValue="value" appendTo="body" [ngModel]="activeFilters.hasComments"
          [placeholder]="header.name" showClear="true" (onClear)="onHistoricHasCommentsChange(null)"
          (onChange)="onHistoricHasCommentsChange($event)"
          [variant]="activeFilters.hasComments != null ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'newDeclaration') {
      <th scope="col" class="historic-compact-col historic-col-related historic-filter-col">
        <div class="historic-header-filter">
        <label class="sr-only" for="historic-filter-related">Tipo de declaración relacionada</label>
        <p-dropdown inputId="historic-filter-related" [options]="declarationTypes"
          optionLabel="label" optionValue="value" appendTo="body" [ngModel]="activeFilters.relatedDeclarationType"
          [placeholder]="header.name" showClear="true" (onClear)="onHistoricRelatedDeclarationChange(null)"
          (onChange)="onHistoricRelatedDeclarationChange($event)"
          [variant]="activeFilters.relatedDeclarationType ? 'filled' : 'outlined'" />
        </div>
      </th>
      }
      @if(isServerSide && header.key === 'log') {
      <th scope="col" class="historic-compact-col historic-col-log">Log</th>
      }

      @if(!isServerSide && header.type === 'text' && header.key !== 'bankAccount' && header.key !== 'client' && header.key !==
      'codeApplication' && header.key !== 'application') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          {{header.name}}
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key" />
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'bankAccount') {
      <th>
        <div [ngStyle]="{'display':'flex','font-size':'13px', 'width': '150px' }">
          {{header.name}}
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'client') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="clientName" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter">
              <p-multiSelect [options]="clientCodes" [(ngModel)]="selectedClientCodes" optionLabel="code"
                optionValue="code" [filter]="true" filterBy="code" showClear="true" appendTo="body"
                [placeholder]="header.name" (onClear)="onClientCodeSelected($event)"
                (onChange)="onClientCodeSelected($event)"
                [variant]="selectedClientCodes.length > 0 ? 'filled' : 'outlined'">
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key"></p-sortIcon>
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'codeApplication') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="codeApplication" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter">
              <p-multiSelect [options]="applicationCodes" [(ngModel)]="selectedApplicationCodes" [filter]="true"
                showClear="true" placeholder="Código Aplicación" appendTo="body"
                (onClear)="onApplicationCodeSelected($event)" (onChange)="onApplicationCodeSelected($event)"
                [variant]="selectedApplicationCodes?.length > 0 ? 'filled' : 'outlined'">
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key"></p-sortIcon>
        </div>
      </th>
      }
      @if(!isServerSide && header.type === 'checkbox') {
      <th>
        <p-checkbox [ngModel]="isAllSelected" [binary]="true" [disabled]="!canSelectAll"
          (ngModelChange)="onSelectAllChange($event)" inputId="selectAll"
          [style.cursor]="canSelectAll ? 'pointer' : 'not-allowed'" />
      </th>
      }
      @if(!isServerSide && header.key === 'hasNotifications'){
      <th>
        <div [ngStyle]="{'display':'flex','font-size':'13px','justify-content':'center'}">
          {{header.name}}
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'observations'){
      <th>
        <div [ngStyle]="{'display':'flex','font-size':'13px'}">
          {{header.name}}
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'model'){
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="model" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [options]="configTable.filtersData.models" [group]="true" optionLabel="name"
                optionValue="name" optionGroupLabel="department" optionGroupChildren="models" appendTo="body"
                [(ngModel)]="selectedModels" [placeholder]="header.name" showClear="true"
                (onClear)="onModelChange($event)" (onChange)="onModelChange($event)"
                [variant]="selectedModels.length > 0 ? 'filled' : 'outlined'" />
            </ng-template>
          </p-columnFilter>
          <p-sortIcon pSortableColumn="model" field="model" />
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'clientName'){
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter style="width: 200px" field="clientName" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter">
              <p-multiSelect [options]="configTable.filtersData.clients" [(ngModel)]="selectedClients"
                optionLabel="name" optionValue="name" appendTo="body" [filter]="true" filterBy="name" showClear="true"
                [placeholder]="header.name" (onClear)="onClientSelected($event)" (onChange)="onClientSelected($event)"
                [variant]="selectedClients.length > 0 ? 'filled' : 'outlined'">
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key"></p-sortIcon>
        </div>
      </th>
      }

      @if(!isServerSide && header.key === 'tasks') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="tasks" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown [options]="configTable.filtersData.fases" [filter]="false" optionLabel="name" appendTo="body"
                optionValue="id" showClear="true" [(ngModel)]="selectedFase" [placeholder]="header.name"
                (onClear)="onPhaseChange($event)" (onChange)="onPhaseChange($event)"
                [variant]="selectedFase ? 'filled' : 'outlined'" />
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'presentationType') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="presentationType" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown [options]="configTable.filtersData.presentationTypes" appendTo="body"
                [(ngModel)]="selectedPresentationTypes" [placeholder]="header.name" showClear="true"
                (onClear)="onPresentationTypesSelected($event)" (onChange)="onPresentationTypesSelected($event)"
                [variant]="selectedPresentationTypes ? 'filled' : 'outlined'" />
            </ng-template>
          </p-columnFilter>
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key" />
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'responsible') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="responsible" matchMode="equals" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter">
              <p-dropdown [options]="configTable.filtersData.users" optionLabel="name" appendTo="body"
                [(ngModel)]="selectedResponsible" [placeholder]="header.name" showClear="true"
                (onClear)="selectedResponsible = null" (onChange)="onResponsibleSelected($event)"
                [variant]="selectedResponsible ? 'filled' : 'outlined'">
              </p-dropdown>
            </ng-template>
          </p-columnFilter>
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key"></p-sortIcon>
        </div>
      </th>
      }
      @if(!isServerSide && header.key === 'executor') {
      <th>
        <div [ngStyle]="{'display':'flex'}">
          <p-columnFilter field="executor" matchMode="in" [showMenu]="false" appendTo="body">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown [options]="configTable.filtersData.executors" [filter]="false" optionLabel="name"
                optionValue="name" appendTo="body" [(ngModel)]="selectedExecutor" [placeholder]="header.name"
                showClear="true" (onClear)="selectedExecutor = null" (onChange)="onExecutorSelected($event)"
                [variant]="selectedExecutor ? 'filled' : 'outlined'" />
            </ng-template>
          </p-columnFilter>
          <p-sortIcon [pSortableColumn]="header.key" [field]="header.key" />
        </div>
      </th>
      }

      }
    </tr>
    }
  </ng-template>

  <ng-template pTemplate="body" let-item>
    @if(isServerSide) {
      @if (item.type === 'NORMAL' || item.type === undefined) {
        <tr [ngClass]="{'expanded-row': item.isExpanded}">
          <td class="historic-col-expand">
            @if(item.declarations?.length > 0) {
              <button type="button" class="expansion-button" [attr.aria-expanded]="item.isExpanded"
                [attr.aria-label]="item.isExpanded ? 'Contraer declaraciones relacionadas' : 'Expandir declaraciones relacionadas'"
                (click)="toggleExpanded(item, $event)">
                <fa-icon class="expansion-icon" [icon]="faChevronDown"></fa-icon>
              </button>
            }
          </td>
          @for (header of configTable.headers; track header.key) {
            @if (header.key === 'newDeclaration') {
              <td class="historic-compact-col historic-col-related" [ngStyle]="{'text-align':'center'}">
                <button type="button" class="button add-button add-button--compact"
                  aria-label="Crear nueva declaración relacionada" (click)="openRelatedDecModal(item.id)">
                  <fa-icon [icon]="faFilePlus"></fa-icon>
                </button>
              </td>
            } @else if (header.key === 'log') {
              <td class="historic-compact-col historic-col-log">
                <button type="button" class="log-button log-button--compact" aria-label="Ver historial de la declaración"
                  (click)="goToLog(item.id)">
                  <fa-icon class="log-icon" [icon]="faClockRotateLeft"></fa-icon>
                </button>
              </td>
            } @else {
              <td (click)="goToDetail(item.id, true)" [ngClass]="getHistoricColumnClass(header.key)"
                [ngStyle]="getHistoricCellStyle(header.key)"
                [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
                @if (header.key === 'observations') {
                  {{ item.observations ? 'Sí' : 'No' }}
                } @else if (header.key === 'state') {
                  @if(item.status === 'FINISHED') {
                    <span class="tag finalized"><fa-icon [icon]="faCircle"></fa-icon>Realizada</span>
                  } @else if(item.status === 'PROGRESS') {
                    <span class="tag pending"><fa-icon [icon]="faCircle"></fa-icon>En progreso</span>
                  } @else {
                    <span class="tag not-finalized"><fa-icon [icon]="faCircle"></fa-icon>No procede</span>
                  }
                } @else if (header.key === 'client') {
                  {{ item.client?.code }}
                } @else if (header.key === 'clientName') {
                  {{ item.client?.name }}
                } @else if (header.key === 'hasNotifications') {
                  @if(item.hasNotifications) {
                    <button type="button" class="contract-warning-badge contract-warning-badge--compact"
                      title="Ver avisos de la declaración" aria-label="Ver avisos de la declaración"
                      (click)="openAvisosModal(item, $event)">
                      <fa-icon [icon]="faTriangleExclamation"></fa-icon>
                    </button>
                  }
                } @else if (header.key === 'model') {
                  {{ item.name }}
                } @else if (header.key === 'responsible') {
                  {{ item.responsible?.name }}
                } @else if (header.key === 'executor') {
                  {{ item.executor }}
                } @else if (header.key === 'dateFinish') {
                  @if (item.dateFinish && item.status !== 'PROGRESS') {
                    {{ item.dateFinish | date: 'dd/MM/yyyy' }}
                  }
                } @else if (header.key === 'presentationType') {
                  {{ item.presentationType }}
                } @else {
                  {{ item[header.key] }}
                }
              </td>
            }
          }
        </tr>
        @if (item.isExpanded && item.declarations) {
          @for (relatedItem of item.declarations; track relatedItem.id) {
            <tr class="expanded-row">
              <td class="historic-col-expand"></td>
              @for (header of configTable.headers; track header.key) {
                @if (header.key === 'newDeclaration') {
                  <td class="historic-compact-col historic-col-related related-decl-type" [ngStyle]="{'text-align':'center'}">
                    {{ TypeDeclarationEnum[relatedItem.type] }}
                  </td>
                } @else if (header.key === 'log') {
                  <td class="historic-compact-col historic-col-log">
                    <button type="button" class="log-button log-button--compact"
                      aria-label="Ver historial de la declaración relacionada" (click)="goToLog(relatedItem.id)">
                      <fa-icon class="log-icon" [icon]="faClockRotateLeft"></fa-icon>
                    </button>
                  </td>
                } @else {
                  <td (click)="goToDetail(relatedItem.id, true)" [ngClass]="getHistoricColumnClass(header.key)"
                    [ngStyle]="getHistoricCellStyle(header.key)">
                    @if (header.key === 'observations') {
                      {{ relatedItem.observations ? 'Sí' : 'No' }}
                    } @else if (header.key === 'state') {
                      @if(relatedItem.status === 'FINISHED') {
                        <span class="tag finalized"><fa-icon [icon]="faCircle"></fa-icon>Realizada</span>
                      } @else if(relatedItem.status === 'PROGRESS') {
                        <span class="tag pending"><fa-icon [icon]="faCircle"></fa-icon>En progreso</span>
                      } @else {
                        <span class="tag not-finalized"><fa-icon [icon]="faCircle"></fa-icon>No procede</span>
                      }
                    } @else if (header.key === 'client') {
                      {{ relatedItem.client?.code }}
                    } @else if (header.key === 'clientName') {
                      {{ relatedItem.client?.name }}
                    } @else if (header.key === 'hasNotifications') {
                      @if(relatedItem.hasNotifications) {
                        <button type="button" class="contract-warning-badge contract-warning-badge--compact"
                          aria-label="Ver avisos de la declaración" (click)="openAvisosModal(relatedItem, $event)">
                          <fa-icon [icon]="faTriangleExclamation"></fa-icon>
                        </button>
                      }
                    } @else if (header.key === 'model') {
                      {{ relatedItem.name }}
                    } @else if (header.key === 'responsible') {
                      {{ relatedItem.responsible?.name }}
                    } @else if (header.key === 'dateFinish') {
                      @if (relatedItem.dateFinish && relatedItem.status !== 'PROGRESS') {
                        {{ relatedItem.dateFinish | date: 'dd/MM/yyyy' }}
                      }
                    } @else if (header.key === 'presentationType') {
                      @if (relatedItem.presentationType) {
                        {{ PresentationTypeEnum[relatedItem.presentationType] || relatedItem.presentationType }}
                      }
                    } @else if (relatedItem[header.key] != null) {
                      {{ relatedItem[header.key] }}
                    }
                  </td>
                }
              }
            </tr>
          }
        }
      }
    } @else {
    <tr>
      @if(item.type === 'model-name') {
      <td colspan="12" [ngStyle]="{'text-align':'left'}">{{ item.name }}</td>
      }@else {
      @for (header of configTable.headers; track header.key) {
      @if (header.key === 'checkbox'){
      <td>
        <p-checkbox [(ngModel)]="item.isChecked" [binary]="true" inputId="binary"
          (ngModelChange)="onCheckboxChange(item)" [disabled]="shouldDisableCheckbox(item)" />
      </td>
      }@else if (header.key === 'log') {
      <td><button (click)="goToLog(item['id'])"><fa-icon class="log-icon" [icon]="faClockRotateLeft"></fa-icon></button>
      </td>
      } @else{
      @if (header.key === 'tasks') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer', 'width':'150px'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        @for (task of item.tasks; track task; let i = $index) {
        @if(task === "FINISHED") {
        @if(item.tasks[i-1] && item.tasks[i-1] !== 'FINISHED') {
        <fa-icon class="circle-icon" [icon]="faCircle"></fa-icon>
        }@else {
        <fa-icon class="check-icon" [icon]="faCircleCheck"></fa-icon>
        }
        } @else if (task === "STARTED"){
        <fa-icon class="progress-circle-icon" [icon]="faCircle"></fa-icon>
        } @else if (task === "NRC_RECEIVED"){
        <fa-icon class="nrc-received-icon" [icon]="faCircle"></fa-icon>
        } @else if (task === "PENDING"){
        <fa-icon class="circle-icon" [icon]="faCircle"></fa-icon>
        } @else if (task === "BLOCKED"){
        <fa-icon class="circle-icon" [icon]="faCircle"></fa-icon>
        } @else if (task === "CARATULA_NRC"){
        <fa-icon class="caratula-nrc-icon" [icon]="faCircle"></fa-icon>
        }
        }
      </td>
      } @else if(header.key === 'observations') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer', 'text-align':'center'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        <span>{{ item[header.key] === true ? 'Sí' : 'No' }}</span>
      </td>
      }
      @else if(header.key === 'state') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        @if(item['status'] === "FINISHED") {
        <span class="tag finalized"><fa-icon [icon]="faCircle"></fa-icon>Realizada</span>
        } @else if(item['status'] === "PROGRESS") {
        <span class="tag "><fa-icon [icon]="faCircle"></fa-icon>En progreso</span>
        } @else {
        <span class="tag not-finalized"><fa-icon [icon]="faCircle"></fa-icon>No procede</span>
        }
      </td>
      } @else if (header.key === 'client') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer', 'text-align':'center'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item[header.key].code }}
      </td>
      } @else if (header.key === 'codeApplication') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer', 'text-align':'center'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item.application.code }}
      </td>
      } @else if (header.key === 'presentationType') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer', 'text-align':'center'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item[header.key] }}
      </td>
      } @else if (header.key === 'clientName') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item.client.name }}
      </td>
      } @else if (header.key === 'hasNotifications') {
      <td [ngStyle]="{'text-align':'center', 'cursor': item.hasNotifications ? 'pointer' : 'default'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        @if(item.hasNotifications) {
        <button type="button" class="contract-warning-badge" title="Ver avisos de la declaración"
          aria-label="Ver avisos de la declaración" (click)="openAvisosModal(item, $event)">
          <fa-icon [icon]="faTriangleExclamation"></fa-icon>
        </button>
        }
      </td>
      } @else if (header.key === 'model') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item.name }}
      </td>
      } @else if (header.key === 'responsible') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        @if (item[header.key] !== null) {
        {{ item[header.key].name }}
        }
      </td>
      } @else if (header.key === 'bankAccount') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer' , 'width': '15%' }"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item[header.key] | ibanFormat }}
      </td>
      } @else if (item[header.key] !== null && header.key !== 'application') {
      <td (click)="goToDetail(item['id'], configTable.historic)" [ngStyle]="{'cursor':'pointer'}"
        [style.pointer-events]="configTable.disableLink ? 'none' : 'auto'">
        {{ item[header.key] }}
      </td>
      }
      }
      }
      }
    </tr>
    }
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="isServerSide ? configTable.headers.length + 1 : 10" class="is-text-size-4">No hay declaraciones</td>
    </tr>
  </ng-template>
</p-table>

@if(!isServerSide) {
<div class="download-button-container" style="display: flex; justify-content: space-between; align-items: center;">
  <div class="declarations-counter" style="font-size: 14px; color: #666;">
    @if(selectedDeclarationsCount > 0) {
    <span>{{ selectedDeclarationsCount }} de {{ totalDeclarations }} declaraciones seleccionadas</span>
    } @else {
    <span>Total: {{ totalDeclarations }} declaraciones</span>
    }
  </div>
  <button class="button is-ghost download-button" (click)="downloadDeclarations()">
    <fa-icon class="button-icon" [icon]="faDownload"></fa-icon>
    Descargar tabla
  </button>
</div>
}

@if (showRelatedDecModal) {
  <app-related-declaration-modal (cancelEvent)="closeRelatedDecModal()" (createEvent)="createRelatedDeclaration($event)"
    #newDecModal></app-related-declaration-modal>
}
<app-declaration-avisos-modal #avisosModal></app-declaration-avisos-modal>
